import { identityService } from "./identityService_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

// SECURITY: these cards show other users' names and blurbs, so every value
// is escaped and every attribute is quoted.
const generateNameHtml = (name) => {
  const namePart = identityService.parseName(name);
  const userID = identityService.parseUserID(name);
  return `${escapeHtml(namePart)} <span class='pAUserIDColor'>(${escapeHtml(userID)})</span>`;
};

const generateHTML = (identity) => {
  let htmlAboveBlurb = `
  <div id="${escapeHtml(identity.userID)}" class="flexColumn ic" style="flex:50%;">
    <div>${generateNameHtml(identity.name)}</div>`;

  let htmlBlurb = `
    <div class="icBlurb">"<em>${escapeHtml(identity.blurb)}</em>"</div>`;

  let htmlBelowBlurb = `</div>`;

  let html2Return = ``;

  if (Object.keys(identity).includes("blurb")) {
    html2Return = htmlAboveBlurb + htmlBlurb + htmlBelowBlurb;
  } else {
    html2Return = htmlAboveBlurb + htmlBelowBlurb;
  }

  return html2Return;
};

export const identityCard = {
  generateHTML,
};
